import { useQuery, keepPreviousData as previousPlaceholder } from '@tanstack/react-query';

import { useApi } from '../contexts/ApiContext';

export default function useBrands(query = null, opts = null) {
    const api = useApi();
    const { keepPreviousData = true } = opts || {};
    const { data = null, ...queryResult } = useQuery({
        queryKey: ['brands', query],
        queryFn: ({ queryKey: [, queryParam], signal }) =>
            api.taxonomies.brands(queryParam, null, null, { signal }),
        suspense: false,
        placeholderData: keepPreviousData ? previousPlaceholder : null,
        ...opts,
    });

    return data !== null
        ? {
              items: data,
              ...queryResult,
          }
        : queryResult;
}
